import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Martini, Cube, Cloud } from '@phosphor-icons/react';

const CocktailDashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cocktail/deployments`, { withCredentials: true });
      setData(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  if (!data) return <div className="p-8 text-center text-slate-500">Loading...</div>;

  const liveCount = data.filter(d => d.status === 'live').length;

  return (
    <div className="space-y-12 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div>
        <h1 className="text-4xl font-black mb-2 text-[#FF0055]">COCKTAIL DASHBOARD</h1>
        <p className="text-slate-400">Overview of mixed Heroku + Azure deployments.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border border-[#FF0055]/20 bg-card p-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500 mb-1">Live Cocktail Apps</div>
            <div className="text-4xl font-black text-white">{liveCount}</div>
          </div>
          <Martini size={48} className="text-[#FF0055] opacity-50" />
        </div>
      </div>

      <div>
        <h2 className="text-2xl font-bold mb-6">RECENT COCKTAIL DEPLOYMENTS</h2>
        <div className="border border-white/10 bg-card p-6 text-center text-slate-400 font-mono">
          See the "Manage URLs" tab for full history and management.
        </div>
      </div>
    </div>
  );
};

export default CocktailDashboard;